import { createApp } from 'vue'
import npm from '@/../package'
import Maska from 'maska'
import VueGoogleMaps from '@fawmi/vue-google-maps'

import OvpIcon from '@/components/Container/Icon'
import Typography from '@/components/Container/Typography'

import config from '@/config'
import events$ from '@/services/Events'
import cobrowse$ from '@/services/Cobrowse'
import Cobrowse from '@/plugins/Cobrowse'
import Tracker from '@/plugins/Tracker'

import '@/assets/css/variables.css'

import useTranslation from '@/hooks/useTranslation'
import useNotifications from '@/hooks/useNotifications'

import tooltip from '@/directives/Tooltip'

import { EVENT_OVP } from '@/config/events'

const { addErrorNotification } = useNotifications()
const { i18n, updateTranslations } = useTranslation()

let isInitialized = false

function appInit(app, __i18n) {
  if (!isInitialized) {
    console.info(
      '%c ⚑ sani%ctas DVP',
      'font-weight:bold;color:#00765A;',
      'font-weight:bold;color:#5BAC26;',
      `v${npm.version}`
    )
    updateTranslations()
    // Cobrowse
    const { locale } = __i18n.global.locale.value
    const { unbluServerUrl, unbluApiKey } = config

    const cobrowseConfig = {
      url: unbluServerUrl,
      key: unbluApiKey,
      locale,
    }
    cobrowse$.setConfig(cobrowseConfig)

    events$.on(EVENT_OVP.ERROR, event => {
      const content = event.eval === true ? eval(`messages.${event.error}`) : event.error
      addErrorNotification(content)
    })
    isInitialized = true
  }
  return app
}

function setup(app) {
  app.provide('version$', npm.version)
  app.provide('appName$', app._component.__name)

  // add global components
  app.component('OvpIcon', OvpIcon)
  app.component('OvpTypography', Typography)
  app.component('Icon', OvpIcon)
  app.component('Typography', Typography)
  app.directive('tooltip', tooltip)

  app.use(Maska)
  app.use(i18n)
  app.use(Cobrowse)
  app.use(VueGoogleMaps, { load: { key: config.googleApiKey } })

  // @NOTE: only initialize once, otherwise all the events get registered (n)-times
  if (!isInitialized) {
    app.use(Tracker)
  }

  return appInit(app, i18n)
}

export { createApp, setup }
